import itemSchema from './schemas/one_789.schema';
import ModuleBase from "@/store/modules/ModuleBase";

const resourceName = 'one_789s'
const base = new ModuleBase(itemSchema, resourceName);
export default {
    namespaced: base.namespaced,
    state: {
        ...base.state,
    },
    getters: {
        ...base.getters,
    },
    mutations: {
        ...base.mutations,
    },
    actions: {
        ...base.actions
    }
}
